// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__1F6po","App-logo":"App_App-logo__i5N9S","App-logo-spin":"App_App-logo-spin__1A12T","App-header":"App_App-header__1mkMi","App-link":"App_App-link__pCso_"};